export const DATE_FORMAT_PASSENGER_CHARTS = 'YYYY-MM-DD'
